<!--
 * @Author: zs
 * @Date: 2022-04-20 14:14:37
 * @LastEditTime: 2022-04-20 16:34:30
 * @Description:
 * @FilePath: \smart-community\src\components\global\Hdetails.vue
-->
<template>
  <div class="details">
    <div class="textbox">
      <el-icon class="closeIcon" @click="changeFlag">
        <close />
      </el-icon>
      <div class="head">
        <div class="border">
          <!-- {{ itemInfo }} -->
          <p>
            {{ itemInfo.sourceName
            }}<span>{{
              moment(parseInt(itemInfo.passTime)).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </p>
        </div>
      </div>
      <div class="body">
        <cutImage v-model:itemInfo="itemInfo"></cutImage>
        <!-- <img :src="itemInfo.fullUrl" alt="" /> -->
      </div>
      <div class="foot">
        <div class="left" @click="onLeft">
          <el-icon :style="{ color: '#4ccbdb' }">
            <arrow-left-bold />
          </el-icon>
        </div>
        <div class="text">
          <ul :style="{ 'margin-left': margin1 + 'px' }">
            <li
              v-for="(item, index) in showList"
              :key="index"
              @mouseover="handleMoreOperation(item, index)"
              @mouseleave="handleMoreLeave(item)"
              @click="scollItem(item)"
              :style="{
                'margin-top': item.resultId === showEareItem ? '-10px' : '0',
              }"
              :class="{ oneItemClick: item.resultId == resultId }"
            >
              <img :src="item.partUrl" alt="" />
            </li>
          </ul>
        </div>
        <div class="right" @click="onRight">
          <el-icon :style="{ color: '#4ccbdb' }">
            <arrow-right-bold />
          </el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
} from "vue";
import cutImage from "./cutImage.vue";
import { Close, ArrowLeftBold, ArrowRightBold } from "@element-plus/icons-vue";
import moment from "moment";
export default defineComponent({
  name: "HDetalis",
  components: { Close, ArrowLeftBold, ArrowRightBold, cutImage },
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
    userList: {
      type: Array,
      required: true,
    },
    item: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      dialogVisble: false,
      margin1: 0,
      showEareItem: false,
      indexList: 1,
      itemInfo: {},
      showList: [],
      indexList: 0,
      resultId: 0, //点击某张照片
    });
    const refData = toRefs(state);
    watchEffect(() => {
      state.dialogVisble = props.visible;
      state.itemInfo = props.item;
      state.resultId = props.item.resultId;

      nextTick(() => {
        props.userList.forEach((item, index) => {
          if (item.resultId == state.itemInfo.resultId) {
            if (index < 9) {
              state.indexList = 0;
            } else {
              state.indexList = parseInt(index / 9);
            }
          }
        });
        state.showList = changeUserList();
      });
    });
    const changeFlag = () => {
      emit("update:visible", false);
    };
    const changeUserList = () => {
      if (state.indexList == parseInt(props.userList.length / 9)) {
        return props.userList.filter((item, index) => {
          return (
            index > parseInt(props.userList.length / 9) * 9 - 1 &&
            index <= props.userList.length - 1
          );
        });
      } else {
        return props.userList.filter((item, index) => {
          return (
            index >= state.indexList * 9 && index < (state.indexList + 1) * 9
          );
        });
      }
    };
    // 向左翻页
    const onLeft = () => {
      state.indexList--;
      if (state.indexList < 0) {
        state.indexList = 1;
        return;
      }
      state.showList = [];
      nextTick(() => {
        state.showList = changeUserList();
      });
    };
    // 向右翻页
    const onRight = () => {
      state.indexList++;
      if (state.indexList > parseInt(props.userList.length / 9)) {
        state.indexList = parseInt(props.userList.length / 9);
        return;
      }
      state.showList = [];
      nextTick(() => {
        state.showList = changeUserList();
      });
    };
    // 鼠标移入显示
    const handleMoreOperation = (item) => {
      state.showEareItem = item.resultId;
    };
    // 鼠标移出隐藏
    const handleMoreLeave = () => {
      state.showEareItem = false;
    };
    // 鼠标点击滚动条中图片
    const scollItem = (item) => {
      console.log(item);
      state.itemInfo = item;
      state.resultId = item.resultId;
    };
    return {
      ...refData,
      changeFlag,
      onLeft,
      onRight,
      handleMoreOperation,
      handleMoreLeave,
      scollItem,
      moment,
    };
  },
});
</script>

<style lang="scss" scoped>
.details {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 100;
  position: relative;
  .textbox {
    width: 1000px;
    height: 710px;
    background: rgba(38, 63, 109, 0.9);
    position: fixed;
    top: 10%;
    bottom: 0;
    left: 10%;
    right: 0;
    margin: auto;
    .closeIcon {
      position: absolute;
      top: 6px;
      right: 8px;
      color: #fff;
      border-radius: 99%;
      background-color: red;
      cursor: pointer;
    }
    .head {
      width: 100%;
      height: 30px;
      padding: 10px 15px;
      .border {
        width: 98%;
        height: 40px;
        text-align: center;
        border-bottom: solid 1px #fff;
        padding-bottom: 10px;
      }
      p {
        color: #fff;
      }
    }
    .body {
      width: 80%;
      height: 500px;
      background: url("~@/assets/images/cardbg.png");
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      img {
        width: 100%;
        height: 100%;
        padding: 20px;
      }
    }
    .foot {
      display: flex;
      width: 100%;
      height: 150px;
      position: absolute;
      bottom: 0;
      .left {
        width: 35px;
        @include flex-col-c-c;
      }
      .text {
        width: 100%;
        overflow: hidden;
        ul {
          margin-top: 35px;
          display: flex;
          li {
            position: relative;
            margin: 15px 4px;
            width: 100px;
            height: 100px;
            background: url("~@/assets/images/cardbg.png");
            background-size: 100% 100%;
            img {
              width: 90px;
              height: 100px;
              padding: 5px;
            }
            .top {
              position: absolute;
              top: 0px;
              right: 5px;
            }
            .bottom {
              position: absolute;
              bottom: 15px;
              width: 80px;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              margin-left: 5px;
            }
          }
          .oneItemClick {
            border: 1px solid #00fafa;
          }
        }
      }
      .right {
        width: 35px;
        @include flex-col-c-c;
      }
    }
  }
}
</style>